import { DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import {
  EVENT_STATUS,
  EVENT_SECTION_TYPE,
  DEFAULT_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME,
} from '../../../constants/service/app/eventConstants';
import moment, { setDateFormat } from '../../../lib/moment';
import { _LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  기획전 리스트 필터 옵션 모델
 */
export const EVENT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  기획전 상태
   */
  status: null,
  /**
   *  기획전 제목
   */
  mainTitle: null,
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품 명
   */
  productName: null,
  /**
   *  상품 1차 카테고리
   */
  mainCategory: null,
  /**
   *  상품 2차 카테고리
   */
  subCategory: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
};

/**
 *  기획전 리스트 정렬 옵션 모델
 */
export const EVENT_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  기획전 정보 모델
 */
export const EVENT_INFO_MODEL = {
  /**
   *  기획전 ID
   */
  eventId: null,
  /**
   *  제목
   */
  mainTitle: null,
  /**
   *  본문
   */
  contents: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  노출순서
   */
  no: null,
  /**
   *  상태
   */
  status: EVENT_STATUS.inactive,
  /**
   *  기획전 기간
   */
  eventPeriod: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_HM_DASH_FORMAT),
    endDate: setDateFormat(moment().add(7, 'day'), DATE_FORMAT.YMD_HM_DASH_FORMAT),
  },
  /**
   *  홈에 노출되는 기간
   */
  exposurePeriod: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_HM_DASH_FORMAT),
    endDate: setDateFormat(moment().add(7, 'day'), DATE_FORMAT.YMD_HM_DASH_FORMAT),
  },
  /**
   *  검색 시 노출되는 이미지
   */
  searchImg: [],
  /**
   *  기획전 아이템
   */
  eventItemList: [],
};

/**
 *  기획전 상품 리스트 필터 옵션 모델
 */
export const EVENT_PRODUCT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  상품 ID
   */
  productId: null,
  /**
   *  상품 명
   */
  productName: null,
};

/**
 *  기획전 섹션 정보 모델
 */
export const EVENT_SECTION_INFO_MODEL = {
  /**
   *  기획전 섹션 ID
   */
  id: null,
  /**
   *  기획전 섹션 타입
   */
  eventSectionType: EVENT_SECTION_TYPE.image,
  /**
   *  기획전 섹션 순서
   */
  eventSectionNo: 1,
  /**
   *  기획전 섹션 이미지 전환 시간 (ms 단위)
   */
  transitionDelay: DEFAULT_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME,
  /**
   *  기획전 이미지 스와이프 인피니티 여부
   */
  isInfinity: false,
  /**
   *  기획전 섹션 이미지
   */
  eventSectionImg: [],
  /**
   *  기획전 섹션 클릭 레이어 리스트
   */
  eventSectionClickLayerList: [],
  /**
   *  기획전 섹션 아이템 리스트
   */
  eventSectionItemList: {
    /**
     *  연결될 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: EVENT_PRODUCT_LIST_FILTER_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};

/**
 *  기획전 섹션 클릭 레이어 모델
 */
export const EVENT_SECTION_CLICK_LAYER_MODEL = {
  /**
   *  x 좌표 (%)
   */
  x: null,
  /**
   *  y 좌표 (%)
   */
  y: null,
  /**
   *  y 좌표 (%)
   */
  width: null,
  /**
   *  y 좌표 (%)
   */
  height: null,
  /**
   *  상품 상세 또는 후기 상세 url
   */
  url: null,
};
